// import { useMount } from 'ahooks';
import { Row } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import ButtonCommon from 'src/components/ButtonCommon';
import styles from './index.module.scss';

const PageNotFound = () => {
  // ============================================================
  // DEPRECATED: "Coming Soon!" auto-redirect behavior
  // This was the previous implementation used as the route errorElement.
  // Hidden/restricted routes should not be treated as "under development"
  // and should not auto-redirect the user. Replaced with a proper
  // 404 / Not Found page that keeps the user on the current page.
  // Kept here for future reference only.
  // ============================================================
  // useMount(() => {
  //   setTimeout(() => {
  //     navigate('/');
  //   }, 1500);
  // });
  //
  // return (
  //   <Row align={'middle'} justify='center'>
  //     <h1 className={styles.title}>Comming Soon!</h1>
  //   </Row>
  // );

  return (
    <Row align={'middle'} justify='center' className={styles.notFound}>
      <div className={styles.notFound__content}>
        <h1 className={styles.notFound__title}>404</h1>
        <p className={styles.notFound__subtitle}>Page Not Found</p>
        <p className={styles.notFound__message}>
          The page you are looking for is not available.
        </p>
      </div>
    </Row>
  );
};

export default PageNotFound;
